import React, {
    useState,
    useEffect
} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
    makeStyles
} from '@material-ui/styles';
import {
    Grid, TableHead
} from '@material-ui/core';
import {
    classBody
} from '@babel/types';
import {
    Card,
    CardActions,
    CardHeader,
    CardContent,
    Button,
    Divider,
    Table,
    TableBody,
    Modal,
    TableRow,
    TextField,
    TableCell,
    colors
} from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment/moment.js'
import { get_booking_info, set_appointment_completed, set_appointment_noshow, delete_booking } from '../../../../api/API';
import ClearIcon from '@material-ui/icons/Clear';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DeleteIcon from '@material-ui/icons/Delete';
import CancelIcon from '@material-ui/icons/Cancel';
import "./Showroom_Booking.css";

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    container: {
        marginTop: theme.spacing(3)
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    }
    // pdTop: {
    //     paddingTop: '30px',
    // }
}));

export default class Showroom_Booking extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            timeslot: null,
            appointment: {
                name: "",
                pax: "",
                contact: "",
                canSetArrive: false,
                canSetNoShow: false,

            },
            role: window.localStorage.getItem("role")
        };
    }


    componentWillReceiveProps(props) {
        console.log('receive props', props);
        this.props = props;
        this.setState({
            ...this.state,
            timeslot: props.timeslot,
            showroom: props.showroom

        });
        this.get_data();


    }
    async get_data() {
        let data = await get_booking_info(this.props.appointment_id);

        if (data) {
            this.setState({
                ...this.state,
                appointment: data
            }, () => {
                let end_time = moment(this.props.date + " " + this.props.timeslot.end_time);
                let booking_date = moment(this.props.date);
                let current_date = moment(new Date());
                let current_time = moment(new Date());

                this.setState({
                    ...this.state,
                    canSetArrive: current_date.isSameOrAfter(booking_date),
                    canSetNoShow: current_time.isSameOrAfter(end_time) && current_date.isSameOrAfter(booking_date)
                });
            });
        }
    }

    componentDidMount() {
        this.get_data();
    }

    async handle_delete() {
        let cfm = window.confirm("Are you sure ?");
        if (cfm) {
            let data = await delete_booking(this.props.appointment_id);
            if (data) {
                alert("Updated");
                this.setState({
                    ...this.state,
                    appointment: {
                        ...this.state.appointment
                    }
                });
                this.props.closeaction();
            }
        }
    }
    async handle_completed() {
        let cfm = window.confirm("Are you sure ?");
        if (cfm) {
            let data = await set_appointment_completed(this.props.appointment_id);
            if (data) {
                alert("Updated");
                this.setState({
                    ...this.state,
                    appointment: {
                        ...this.state.appointment,
                        status: 1
                    }
                });
            }
        }

    }

    async handle_noshow() {
        let cfm = window.confirm("Are you sure ?");
        if (cfm) {
            let data = await set_appointment_noshow(this.props.appointment_id);
            if (data) {
                alert("Updated");
                this.setState({
                    ...this.state,
                    appointment: {
                        ...this.state.appointment,
                        status: 2
                    }
                });
            }
        }

    }
    render() {
        return (
            <Modal
                className={this.props.classes.modal + " hide_scroll modal_custom"}
                open={this.props.open}
                style={{
                    marginLeft: "auto",
                    marginTop: "2%",
                    marginRight: "auto",
                    overflow: "scroll"
                }}
                onClose={this.props.closeaction}
            >
                <React.Fragment>
                    <Card>
                        <CardHeader title="Appointment Info">
                            <TextField />
                        </CardHeader>
                        <CardContent>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Agency</TableCell>
                                        <TableCell>{this.state.appointment.agency_name}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Agent Name</TableCell>
                                        <TableCell>{this.state.appointment.agent_name}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Agent Contact</TableCell>
                                        <TableCell>{this.state.appointment.agent_contact}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Agent Email</TableCell>
                                        <TableCell>{this.state.appointment.agent_email}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Number of people</TableCell>
                                        <TableCell>{this.state.appointment.pax}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Number of agents</TableCell>
                                        <TableCell>{this.state.appointment.agent_pax}</TableCell>
                                    </TableRow>
                                    {this.state.appointment.require_showroom_unit == "1" && (
                                        <TableRow>
                                            <TableCell>Showflat Unit</TableCell>
                                            <TableCell>{this.state.appointment.unit}</TableCell>
                                        </TableRow>)
                                    }
                                    <TableRow>
                                        <TableCell>Guest nationality</TableCell>
                                        <TableCell>{this.state.appointment.guest_nationality}</TableCell>
                                    </TableRow>
                                    {/* <TableRow>
                                        <TableCell>Contact</TableCell>
                                        <TableCell>{this.state.appointment.contact}</TableCell>
                                    </TableRow> */}
                                    {/* <TableRow>
                                        <TableCell>Prospect Name</TableCell>
                                        <TableCell>{this.state.appointment.prospect_name}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Prospect Contact</TableCell>
                                        <TableCell>{this.state.appointment.prospect_contact}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Prospect Email</TableCell>
                                        <TableCell>{this.state.appointment.prospect_email}</TableCell>
                                    </TableRow> */}
                                </TableBody>
                            </Table>
                        </CardContent>
                        <CardActions className={this.props.classes.flexend} style={{
                            alignItems: "space-between",
                            justifyContent: "space-between"
                        }}>
                            {
                                this.state.role == 'admin' || this.state.role == 'superadmin' ?
                                    <Button
                                        className={this.props.classes.saveButton}
                                        variant="contained"
                                        onClick={this.handle_delete.bind(this)}
                                        style={{
                                            backgroundColor: "red",

                                        }}
                                    >
                                        <DeleteIcon></DeleteIcon>
                                        <span className="hide_mobile">Delete</span>
                                    </Button> : ''
                            }

                            {
                                this.state.appointment.status == 0 && this.state.canSetNoShow ?
                                    <Button
                                        className={this.props.classes.saveButton}
                                        variant="contained"
                                        onClick={this.handle_noshow.bind(this)}
                                        style={{
                                            backgroundColor: "red"
                                        }}
                                    >
                                        <ClearIcon />
                                        <span className="hide_mobile">No Show</span>
                                    </Button>
                                    : ''}
                            {
                                this.state.appointment.status == 0 && this.state.canSetArrive ?
                                    <Button
                                        className={this.props.classes.saveButton}
                                        variant="contained"
                                        onClick={this.handle_completed.bind(this)}
                                    >
                                        <DoneAllIcon></DoneAllIcon>
                                        <span className="hide_mobile">Arrived 1</span>

                                    </Button> : ''
                            }
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: "black"
                                }}
                                onClick={this.props.closeaction.bind(this)}
                            >
                                <CancelIcon className={this.props.classes.leftIcon} />
                                <span className="hide_mobile">Back</span>
                            </Button>
                        </CardActions>
                    </Card>
                </React.Fragment>
            </Modal>
        )
    }

} 
